/** WebSocket event names (§48). */
export const RealtimeEvent = {
  ATTENDANCE_CLOCKED_IN: 'attendance.clocked_in',
  ATTENDANCE_CLOCKED_OUT: 'attendance.clocked_out',
  ATTENDANCE_LATE: 'attendance.late',
  ATTENDANCE_FLAGGED: 'attendance.flagged',
  ATTENDANCE_CORRECTED: 'attendance.corrected',
  ATTENDANCE_VERIFIED: 'attendance.verified',
  ATTENDANCE_APPROVED: 'attendance.approved',
  ATTENDANCE_REJECTED: 'attendance.rejected',
  FACULTY_CURRENTLY_TEACHING: 'faculty.currently_teaching',
  MAKEUP_SUBMITTED: 'makeup.submitted',
  MAKEUP_APPROVED: 'makeup.approved',
  SUBSTITUTION_APPROVED: 'substitution.approved',
  PAYROLL_READY: 'payroll.ready',
  PAYROLL_LOCKED: 'payroll.locked',
  NOTIFICATION_CREATED: 'notification.created',
  /** Any change to an approval request (submitted, decided, cancelled); refreshes inboxes. */
  APPROVAL_UPDATED: 'approval.updated',
  /** A payroll cut-off changed status (review, finalized, locked, processed, reopened). */
  PAYROLL_PERIOD_UPDATED: 'payroll.period_updated',
} as const;
export type RealtimeEvent = (typeof RealtimeEvent)[keyof typeof RealtimeEvent];

/** Payload of `approval.updated`, `makeup.*` and `substitution.*` events. */
export interface ApprovalRealtimePayload {
  approvalRequestId: string | null;
  workflowCode: string;
  entityType: string;
  entityId: string;
  status: string;
  facultyId: string | null;
  departmentId: string | null;
  collegeId: string | null;
  at: string;
}

/** Payload of `payroll.period_updated`, `payroll.ready` and `payroll.locked`. */
export interface PayrollRealtimePayload {
  periodId: string;
  name: string;
  status: string;
  at: string;
}

/** Room naming (§48). Clients only join rooms authorized by role and scope. */
export const RealtimeRoom = {
  faculty: (facultyId: string) => `faculty:${facultyId}`,
  department: (departmentId: string) => `department:${departmentId}`,
  college: (collegeId: string) => `college:${collegeId}`,
  adminAttendance: 'admin:attendance',
  user: (userId: string) => `user:${userId}`,
} as const;
